import React from 'react';

import { useIsFetching } from 'react-query';

import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { GlobalFilterButton } from 'components/common/GlobalFilterButton/GlobalFilterButton';
import { GlobalFilterComponent } from 'components/common/GlobalFilterComponent/GlobalFilterComponent';
import { ActivityCodesFilter } from 'components/common/GlobalFilterComponent/components/ActivityCodesFilter/ActivityCodesFilter';
import { MilestoneFragnetFilter } from 'components/common/GlobalFilterComponent/components/MilestoneFragnetFilter/MilestoneFragnetFilter';
import { TagsFilter } from 'components/common/GlobalFilterComponent/components/TagsFilter/TagsFilter';
import { WbsFilter } from 'components/common/GlobalFilterComponent/components/WbsFilter/wbsFilter';
import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { useScrollTo } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramProgressOverview/useScrollTo';
import { ProgramStatusSummaryReportQueryKeys } from 'components/Dashboards/Project/Components/VersionCompare/VersionCompare.consts';
import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import { TreeProgramTopHeader, VersionCompareSelectorWrapper } from 'components/common';
import { KeyAchievements } from 'components/widgets/KeyAchievements/keyAchievements';
import { KeyActivities } from 'components/widgets/KeyActivities/KeyActivities';
import { PrioritiesMatrix } from 'components/widgets/PrioritiesMatrix/prioritiesMatrix';
import { ProjectSummary } from 'components/widgets/ProjectSummary/ProjectSummary';
import { SummaryTrackedActivitiesComponent } from 'components/widgets/SummaryTrackedActivities/summaryTrackedActivitiesComponent';

export const ProjectStatusPage = () => {
    useFullStoryPageView({ pageName: executionConfig.statusSummary.title });
    const isFetching = useIsFetching({
        predicate: (query) => {
            const key = Array.isArray(query.queryKey) ? query.queryKey[0] : query.queryKey;
            return ProgramStatusSummaryReportQueryKeys.includes(key);
        },
    });
    useScrollTo(isFetching);

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader>
                            <VersionCompareSelectorWrapper isBaselineSelected={true} allowSingleVersion={true} />
                        </TreeProgramTopHeader>
                    </VersionSection>
                    <GlobalFilterButton />
                </VersionWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={executionConfig.statusSummary.title} />
                    <GlobalFilterComponent
                        defaultValues={{ milestoneFragnet: null, tags: [], activityCodes: [], wbs: null }}
                    >
                        <MilestoneFragnetFilter name={'milestoneFragnet'} />
                        <TagsFilter name={'tags'} />
                        <ActivityCodesFilter name={'activityCodes'} />
                        <WbsFilter name={'wbs'} />
                    </GlobalFilterComponent>
                </BottomHeaderSection>
            </HeaderWrapper>

            <MainContent>
                <PageWidgetWrapper>
                    <ProjectSummary />
                    <PrioritiesMatrix />
                    <KeyAchievements />
                    <KeyActivities />
                    <SummaryTrackedActivitiesComponent />
                </PageWidgetWrapper>
            </MainContent>
            <MainCardRoutingModal queryKeys={ProgramStatusSummaryReportQueryKeys} />
        </PageContainer>
    );
};
